export default {
  confirmDelete: {
    header: 'Potvrdiť reset',
    message: 'Odstránením tohto parametra sa na zariadenie {asset} použije parameter nadradeného zariadenia.\nAk žiadne nadradené zariadenie parameter nedefinuje, použije sa predvolená hodnota.\n\nNaozaj chcete odstrániť parameter \'{parameter}\' pre \'{asset}\'?',
  },
};
